export const  kidStatusList = [
    {key: "STUDYING", value: "Đang học", label: "Đang học"},
    {key: "STUDY_WAIT", value: "Chờ học",label: "Chờ học"},
    {key: "RESERVE", value: "Bảo lưu",label: "Bảo lưu"},
    {key: "LEAVE_SCHOOL", value: "Nghỉ học",label: "Nghỉ học"},
]

export const  kidStatusListExcel = [
    {key: "STUDYING", value: "Đang học", label: "Đang học"},
    {key: "STUDY_WAIT", value: "Chờ học",label: "Chờ học"},
    {key: "RESERVE", value: "Bảo lưu",label: "Bảo lưu"},
    {key: "LEAVE_SCHOOL", value: "Nghỉ học",label: "Nghỉ học"},
    {key: "OUT_SCHOOL", value: "Ra trường",label: "Ra trường"},
]
export const  loginStatusList = [
    {key: "loginYet", value: "Chưa từng đăng nhập"},
    {key: "loginNo", value: "Không đăng nhập"},
    {key: "loginYes", value: "Đã đăng nhập"},
]
export const statusEmployeeList = ["Đang làm", "Tạm nghỉ", "Nghỉ làm"]
export const appTypeList = [
    { key: "plus", value: "Nhà trường" },
    { key: "teacher", value: "Giáo viên" },
    { key: "parent", value: "Phụ huynh" },
]

export const  appType = {
    SUPPER_SYSTEM: "supperSys",
    SYSTEM: "sys",
    AGENT: "agent",
    SUPPER_SCHOOL: "supperPlus",
    SCHOOL: "plus",
    TEACHER: "teacher",
    PARENT: "parent",
}

export const companyInfo = [
    "Công ty Cp Ứng dụng trường Mầm non OneKids",
    "Địa chỉ 62 Trương Công Giai, phường Dịch Vọng, quận Cầu Giấy, tp Hà Nội"
]

export const statusEmployeeListNew = ["Đang làm", "Tạm nghỉ", "Nghỉ làm","Nghỉ hẳn"]

export const  optionSerialNumberShowNewsHomeMap = [
    {key: "1", value: "Tin tức"},
    {key: "2", value: "Facebook"},
    {key: "3", value: "Video"},
]

export const  kidStatusListOneAdmin = [
    {key: "STUDYING", value: "Đang học", label: "Đang học"},
    {key: "STUDY_WAIT", value: "Chờ học",label: "Chờ học"},
    {key: "RESERVE", value: "Bảo lưu",label: "Bảo lưu"},
    {key: "LEAVE_SCHOOL", value: "Nghỉ học",label: "Nghỉ học"},
    {key: "OUT_SCHOOL", value: "Ra trường",label: "Ra trường"},
]
// export const statusEmployeeListOneAdmin = ["Đang làm", "Tạm nghỉ", "Nghỉ làm, Nghỉ hẳn"]
export const statusEmployeeListOneAdmin = [
    {value: "Đang làm", label: "Đang làm"},
    {value: "Tạm nghỉ",label: "Tạm nghỉ"},
    {value: "Nghỉ làm",label: "Nghỉ làm"},
    {value: "Nghỉ hẳn",label: "Nghỉ hẳn"},
]

export const statusPackages = [
    {
        value: "remain",
        label: "Còn hạn",
    },
    {
        value: "expiredExtend",
        label: "Hết hạn còn đăng ký",
    },
    {
        value: "expiredNotExtend",
        label: "Hết hạn không đăng ký",
    }
]

export const packageDelActive = [
    {
        value: true,
        label: "Đang sử dụng",
    },
    {
        value: false,
        label: "Đã xoá"
    }
]

export const statusFinance = [
    {
        value: "NO_MONEY_PAYMENT",
        label: "Chưa đóng 100%"
    },
    {
        value: "NO_MONEY_PAYMENT_FULL",
        label: "Chưa đóng đủ"
    },
    {
        value: "YES_MONEY_PAYMENT_FULL",
        label: "Đóng đủ 100%"
    },
    {
        value: "YES_PAYMENT_OVERALL_MONEY",
        label: "Đóng thừa"
    },
    {
        value: "YES_MONEY_NEXT_MONTH",
        label: "Đóng đủ thừa"
    },
    {
        value: "NO_PAYMENT_NEXT_MONTH",
        label: "Đóng đủ thiếu"
    },
]

export const colorText = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0066cc",
    "#9933ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    "#bbbbbb",
    "#f06666",
    "#ffc266",
    "#ffff66",
    "#66b966",
    "#66a3e0",
    "#c285ff",
    "#888888",
    "#a10000",
    "#b26b00",
    "#b2b200",
    "#006100",
    "#0047b2",
    "#6b24b2",
    "#444444",
    "#5c0000",
    "#663d00",
    "#666600",
    "#003700",
    "#002966",
    "#3d1466",
]

export const statusBrand = [
    {
        value: "Pending",
        label: "Đang chờ xử lý",
    },
    {
        value: "Active",
        label: "Đang hoạt động",
    },
    {
        value: "Suspended",
        label: "Đã tạm ngừng",
    },
    {
        value: "Terminated",
        label: "Đã chấm dứt",
    },
    {
        value: "Cancelled",
        label: "Đã hủy",
    },
    {
        value: "Fraud",
        label: "Gian lận",
    }
]

export const notifySendType ={
    IMMEDIATE : "IMMEDIATE",
    SCHEDULED : "SCHEDULED",
    SUCCESS : "SUCCESS",
    FAIL : "FAIL"
}